/* SPOTEC — tombol "Message us" (Shopify Inbox) bisa diperkecil (9 Okt 2026).
   - Tombol kecil "–" di sudut tombol chat: menyembunyikan "Message us" dan menggantinya dengan ikon chat bulat kecil.
   - Ketuk ikon bulat: "Message us" muncul lagi.
   - Pilihan pelanggan diingat di browser itu (pindah halaman tetap sama).
   - Default: di halaman produk pada HP/tablet (< 990px) mulai dalam keadaan kecil, karena tombol chat menutupi
     pilihan ukuran & tombol beli. Ubah di DEFAULT_MIN di bawah.
   Teks & warna "Message us" tetap dari pengaturan aplikasi Shopify Inbox. */
(() => {
  if (window.spotecChatDock) return;
  window.spotecChatDock = true;

  const DEFAULT_MIN = {
    productMobile: true,   // halaman produk, layar < 990px
    other: false           // halaman lain
  };
  const KEY = 'spx-chat-min';
  const TEXT = { hide: 'Hide chat button', show: 'Chat with us' };
  const HOSTS = 'shopify-chat, inbox-online-store-chat';
  const STYLE_ID = 'spx-chat-dock-style';

  const store = {
    get() { try { return localStorage.getItem(KEY); } catch (error) { return null; } },
    set(value) { try { localStorage.setItem(KEY, value); } catch (error) {} }
  };
  const defaultMin = () => {
    const isProduct = !!document.querySelector('product-info') || /\/products\//.test(location.pathname);
    return isProduct && matchMedia('(max-width: 989px)').matches ? DEFAULT_MIN.productMobile : DEFAULT_MIN.other;
  };
  const wantMin = () => {
    const saved = store.get();
    return saved === null ? defaultMin() : saved === '1';
  };

  // Light-DOM styles for the small round button.
  const css = document.createElement('style');
  css.textContent = `
    @property --spx-ring { syntax: '<angle>'; inherits: true; initial-value: 0deg; }
    .spx-chat-mini { position: fixed; z-index: 2147483000; right: var(--spx-mini-right, 16px); bottom: var(--spx-mini-bottom, 20px);
      width: 48px; height: 48px; border-radius: 50%; padding: 0; color: #121212; cursor: pointer;
      display: grid; place-items: center; isolation: isolate;
      background: rgba(255,255,255,.9); border: 1px solid rgba(255,255,255,.7);
      box-shadow: 0 10px 28px -8px rgba(0,0,0,.28), 0 2px 6px rgba(0,0,0,.08), inset 0 1px 0 rgba(255,255,255,.95), inset 0 -1px 0 rgba(0,0,0,.06);
      opacity: 0; transform: translateY(6px) scale(.6); pointer-events: none;
      transition: opacity .3s cubic-bezier(.22,1,.36,1), transform .35s cubic-bezier(.22,1,.36,1), box-shadow .3s cubic-bezier(.22,1,.36,1); }
    @supports ((-webkit-backdrop-filter: blur(1px)) or (backdrop-filter: blur(1px))) {
      .spx-chat-mini { background: linear-gradient(160deg, rgba(255,255,255,.82) 0%, rgba(255,255,255,.42) 55%, rgba(255,255,255,.6) 100%); -webkit-backdrop-filter: blur(18px) saturate(180%); backdrop-filter: blur(18px) saturate(180%); }
    }
    /* thin chrome ring, same family as the SPOTEC logo shine */
    .spx-chat-mini::after { content: ""; position: absolute; inset: -1px; border-radius: inherit; padding: 1px; pointer-events: none; z-index: -1;
      background: conic-gradient(from var(--spx-ring), rgba(255,255,255,.95), rgba(150,150,150,.55), rgba(255,255,255,.95), rgba(110,110,110,.45), rgba(255,255,255,.95));
      -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0); -webkit-mask-composite: xor;
      mask: linear-gradient(#000 0 0) content-box exclude, linear-gradient(#000 0 0); }
    .spx-chat-mini.is-left { right: auto; left: var(--spx-mini-left, 16px); }
    html.spx-chat-is-min .spx-chat-mini { opacity: 1; transform: none; pointer-events: auto; animation: spx-ring-sweep 1.1s cubic-bezier(.22,1,.36,1) .15s 1; }
    .spx-chat-mini:hover { transform: translateY(-2px); box-shadow: 0 14px 32px -8px rgba(0,0,0,.32), 0 2px 6px rgba(0,0,0,.08), inset 0 1px 0 rgba(255,255,255,.95), inset 0 -1px 0 rgba(0,0,0,.06); animation: spx-ring-sweep 1.1s cubic-bezier(.22,1,.36,1) 1; }
    .spx-chat-mini:active { transform: scale(.94); }
    .spx-chat-mini:focus-visible { outline: 2px solid #121212; outline-offset: 3px; }
    .spx-chat-mini svg { width: 22px; height: 22px; }
    @keyframes spx-ring-sweep { from { --spx-ring: 0deg; } to { --spx-ring: 360deg; } }
    html.spx-nd-lock .spx-chat-mini, html.spx-lock .spx-chat-mini, html.spx-fav-lock .spx-chat-mini,
    html.spx-sg-lock .spx-chat-mini, html.spx-loc-lock .spx-chat-mini { opacity: 0 !important; pointer-events: none !important; }
    @media (prefers-reduced-motion: reduce) { .spx-chat-mini { transition: opacity .2s linear; animation: none !important; transform: none !important; } }
  `;
  document.head.appendChild(css);

  // Styles injected into the chat app's own (open) shadow root.
  const shadowCss = `
    .spx-chat-hide { position: absolute; top: -10px; left: -10px; z-index: 5; width: 26px; height: 26px; padding: 0;
      border-radius: 50%; color: #121212; cursor: pointer; display: grid; place-items: center; isolation: isolate;
      background: rgba(255,255,255,.92); border: 1px solid rgba(255,255,255,.75);
      box-shadow: 0 6px 16px -4px rgba(0,0,0,.25), inset 0 1px 0 rgba(255,255,255,.95), inset 0 -1px 0 rgba(0,0,0,.06);
      transition: transform .3s cubic-bezier(.22,1,.36,1), box-shadow .3s cubic-bezier(.22,1,.36,1); }
    @supports ((-webkit-backdrop-filter: blur(1px)) or (backdrop-filter: blur(1px))) {
      .spx-chat-hide { background: linear-gradient(160deg, rgba(255,255,255,.85) 0%, rgba(255,255,255,.4) 60%, rgba(255,255,255,.62) 100%); -webkit-backdrop-filter: blur(14px) saturate(180%); backdrop-filter: blur(14px) saturate(180%); }
    }
    .spx-chat-hide::before { content: ""; position: absolute; inset: -9px; }  /* 44px touch area */
    .spx-chat-hide::after { content: ""; position: absolute; inset: -1px; border-radius: inherit; padding: 1px; pointer-events: none; z-index: -1;
      background: conic-gradient(from var(--spx-ring, 0deg), rgba(255,255,255,.95), rgba(150,150,150,.55), rgba(255,255,255,.95), rgba(110,110,110,.45), rgba(255,255,255,.95));
      -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0); -webkit-mask-composite: xor;
      mask: linear-gradient(#000 0 0) content-box exclude, linear-gradient(#000 0 0); }
    .spx-chat-hide:hover { transform: scale(1.1); box-shadow: 0 8px 20px -4px rgba(0,0,0,.3), inset 0 1px 0 rgba(255,255,255,.95), inset 0 -1px 0 rgba(0,0,0,.06); animation: spx-ring-sweep 1.1s cubic-bezier(.22,1,.36,1) 1; }
    .spx-chat-hide:active { transform: scale(.9); }
    .spx-chat-hide:focus-visible { outline: 2px solid #121212; outline-offset: 2px; }
    .spx-chat-hide svg { width: 12px; height: 12px; }
    @keyframes spx-ring-sweep { from { --spx-ring: 0deg; } to { --spx-ring: 360deg; } }
    :host(.spx-chat-min) .activator-nudge { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important;
      transition: opacity .2s cubic-bezier(.22,1,.36,1), visibility 0s .2s !important; }
    .activator-nudge { transition: opacity .25s cubic-bezier(.22,1,.36,1); }
    @media (prefers-reduced-motion: reduce) { .spx-chat-hide { transition: none; animation: none !important; } }
  `;

  const icon = {
    minus: '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M3 6h6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>',
    chat: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 5.5A2.5 2.5 0 0 1 6.5 3h11A2.5 2.5 0 0 1 20 5.5v8a2.5 2.5 0 0 1-2.5 2.5H10l-4.5 4v-4h0A1.5 1.5 0 0 1 4 14.5z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/></svg>'
  };

  const mini = document.createElement('button');
  mini.type = 'button';
  mini.className = 'spx-chat-mini';
  mini.setAttribute('aria-label', TEXT.show);
  mini.innerHTML = icon.chat;
  mini.hidden = true;
  document.body.appendChild(mini);

  let host = null;

  const launcher = () => host && host.shadowRoot && host.shadowRoot.querySelector('.activator-nudge');
  const chatOpen = () => {
    if (!host || !host.shadowRoot) return false;
    // the chat window is a large panel inside the app's layer
    return Array.from(host.shadowRoot.querySelectorAll('div')).some((el) => {
      if (el === launcher()) return false;
      const r = el.getBoundingClientRect();
      return r.height > 240 && r.width > 200 && r.width < innerWidth - 1 && getComputedStyle(el).visibility !== 'hidden';
    });
  };

  // Put the round button where the launcher sits (same side, same height above the tab bar).
  const place = () => {
    const box = launcher();
    if (!box) return;
    const r = box.getBoundingClientRect();
    if (!r.width) return;
    const left = r.left + r.width / 2 < innerWidth / 2;
    mini.classList.toggle('is-left', left);
    mini.style.setProperty('--spx-mini-bottom', Math.max(8, Math.round(innerHeight - r.bottom)) + 'px');
    mini.style.setProperty(left ? '--spx-mini-left' : '--spx-mini-right', Math.max(8, Math.round(left ? r.left : innerWidth - r.right)) + 'px');
  };

  const apply = (min, remember) => {
    if (remember) store.set(min ? '1' : '0');
    if (!host) return;
    if (min) place();
    host.classList.toggle('spx-chat-min', min);
    document.documentElement.classList.toggle('spx-chat-is-min', min);
    mini.hidden = false;
    if (remember) {
      const target = min ? mini : host.shadowRoot && host.shadowRoot.querySelector('.activator');
      if (target) requestAnimationFrame(() => target.focus({ preventScroll: true }));
    }
  };

  const decorate = () => {
    const box = launcher();
    if (!box) return false;
    const shadow = host.shadowRoot;
    if (!shadow.getElementById(STYLE_ID)) {
      const style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = shadowCss;
      shadow.appendChild(style);
    }
    if (!box.querySelector('.spx-chat-hide')) {
      const hide = document.createElement('button');
      hide.type = 'button';
      hide.className = 'spx-chat-hide';
      hide.setAttribute('aria-label', TEXT.hide);
      hide.innerHTML = icon.minus;
      hide.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); apply(true, true); });
      box.appendChild(hide);
    }
    const hideButton = box.querySelector('.spx-chat-hide');
    if (hideButton) hideButton.hidden = chatOpen();
    return true;
  };

  mini.addEventListener('click', () => apply(false, true));

  const attach = (el) => {
    if (!el || !el.shadowRoot || el === host) return;
    host = el;
    let queued = false;
    const refresh = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => {
        queued = false;
        if (!decorate()) return;
        const open = chatOpen();
        mini.style.visibility = open ? 'hidden' : '';
        if (host.classList.contains('spx-chat-min') && !open) place();
      });
    };
    new MutationObserver(refresh).observe(host.shadowRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    addEventListener('resize', refresh, { passive: true });
    // the tab bar lifts the launcher when it appears/disappears; follow it
    addEventListener('scroll', () => { if (host.classList.contains('spx-chat-min')) refresh(); }, { passive: true });
    const start = () => { if (decorate()) apply(wantMin(), false); else setTimeout(start, 250); };
    start();
  };

  const find = () => attach(document.querySelector(HOSTS));
  find();
  if (!host) {
    const watch = new MutationObserver(() => { find(); if (host) watch.disconnect(); });
    watch.observe(document.body, { childList: true });
    setTimeout(() => watch.disconnect(), 30000);
  }
})();
